'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hourAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/hourAgo.js
// module id = 677
// module chunks = 0